import background from '@/assets/images/selling-point-bg.jpeg';
import { sellingPoints } from '@/screens/services/NewSellingPoints';
import Point from '@/components/Point';
import ScrollableContainer from '@/components/ScrollableContainer';
import { useTranslation } from 'react-i18next';

const SellingPoint = () => {
  const { t } = useTranslation();
  const translatedPoints = t('sellingPoints.points', { returnObjects: true }) as Array<{ title: string; description: string }>;

  return (
    <section
      style={style.background}
      className="py-20 relative overflow-hidden"
    >
      {/* Background overlay with blur */}
      <div style={style.overlay} className="absolute inset-0"></div>

      <div className="container mx-auto relative z-10">
        <h2 className="text-4xl font-bold text-center text-white mb-12">
          {t('sellingPoints.title')}
        </h2>

        {/* Use ScrollableContainer for horizontal scrolling with arrows */}
        <ScrollableContainer className="p-8 md:px-0" scrollAmount={350}>
          <div className="flex flex-nowrap gap-4 mx-auto">
            {translatedPoints.map((point, index) => (
              <div key={index} className="flex-none">
                <Point
                  title={point.title}
                  description={point.description}
                  icon={sellingPoints[index].icon}
                />
              </div>
            ))}
          </div>
        </ScrollableContainer>
      </div>
    </section>
  );
};

const style = {
  background: {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.65)",
    backdropFilter: "blur(1.5px)",
    position: "absolute" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}

export default SellingPoint;